import { MenuItem } from 'vue-graphql-models';

export default [
  new MenuItem({
    id: 'recordCreate',
    title: 'Upload File',
    subtitle: 'Upload a new file to a current folder',
    icon: 'cloud_upload',
  }),
  new MenuItem({
    id: 'directoryCreate',
    title: 'Create Folder',
    subtitle: 'Create a new folder',
    icon: 'create_new_folder',
  }),
];
